import React from 'react';
import classNames from 'classnames';
import { Icon } from '@eventbrite/legacy-eds.icon';
import { TABBABLE_INDEX } from '@eventbrite/legacy-eds.hot-keys';
import { ChevronUpChunky, ChevronDownChunky } from '@eventbrite/legacy-eds.iconography';
import styles from './DropLink.module.scss';
import { injectIntl } from 'react-intl';

class DropLinkComponent extends React.PureComponent {
    componentDidUpdate() {
        const { tabIndex, shouldFocusDropLink } = this.props;
        return tabIndex === TABBABLE_INDEX && shouldFocusDropLink ? this._focus() : this._blur();
    }

    _getRef(ref) {
        this._link = ref;
        return this._link;
    }

    _blur() {
        this._link.blur();
    }

    _focus() {
        this._link.focus();
    }

    _getAriaLabel() {
        const { children, ariaLabelContent, intl } = this.props;
        const childLabel = children?.props?.label;

        if (childLabel) {
            return childLabel;
        }

        const baseLabel = intl.formatMessage({
            id: 'Dropdown menu',
            defaultMessage: 'Dropdown menu',
        });
        if (!ariaLabelContent) {
            return baseLabel;
        }

        const withLabel = intl.formatMessage({ id: 'with label', defaultMessage: 'with label' });

        return `${baseLabel} ${withLabel} ${ariaLabelContent}`;
    }

    render() {
        const { children, fallbackUrl, dropUp, onClick, tabIndex, hideDropIconWhenNarrow, role } =
            this.props;
        const iconType = dropUp ? <ChevronUpChunky /> : <ChevronDownChunky />;
        const iconClassName = classNames(styles.icon, {
            [styles.iconNarrowBreakpoints]: hideDropIconWhenNarrow,
        });

        return (
            <a
                className={styles.root}
                href={fallbackUrl}
                onClick={onClick}
                data-testid="dropdown-link"
                role={role ?? 'menuitem'}
                ref={this._getRef.bind(this)}
                onMouseEnter={this._focus.bind(this)}
                onMouseLeave={this._blur.bind(this)}
                tabIndex={tabIndex}
                aria-label={this._getAriaLabel()}
            >
                <div className={styles.contents} data-testid="dropdown-link-contents">
                    {children}
                </div>
                <span className={iconClassName} data-testid="dropdown-link-icon">
                    <Icon type={iconType} color="grey-400" isBlockLevel={true} />
                </span>
            </a>
        );
    }
}

export const DropLink = injectIntl(DropLinkComponent);
